/* src/app/modules/shared/components/column/column-energy-score/column-energy-score.component.scss */
app-column-energy-score {
  display: contents;
}
/*# sourceMappingURL=column-energy-score.component.css.map */
